import env from '../env.js'
import { getUserData } from '@/helpers/utils'

const state = {
    isLoading: false,
    AppActiveUser: getUserData(),
    domain: env.domain,
    localUserKey: env.localUserKey,
    appName: env.appName,
    config:{
      shortDesc: "",
    },
    appConfigData:{
        statusColors: []
    },
    scrollY: 0,
    windowWidth: window.innerWidth,
    countries: [],
    localGovernments: [],
    dashboardData:{
        "unread_notifications": 0,
        "user": null,
        "employee": null,
        "verification": null,
        "payroll_data": {
            "basic_salary": 0,
            "total_allowances": 0,
            "total_deductions": 0,
            "gross_pay": 0,
            "net_pay": 0,
            "arrears": 0,
            "refunds": 0,
            "tax": 0,
            "nhf": 0,
            "hic": 0,
            "total_loans": 0,
            "union_dues": 0,
            "contributions": 0
        }
    },
    lightbox:{
      index: null,
      visible: false,
      files: []
    },
    pdfModalFrame:{
      visible: false,
      filePath: ""
    },
}

export default state
